export class MemberTypeConstants{
    public static AssistantManagerAndBelow = 'Assistant Manager and Below';
    public static ManagersAndAbove = 'Managers and Above';
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/memberlevel-type.constants.ts